import type { ReleaseEntry } from '../content/types';

/** Count entries strictly newer than the last-seen marker. `null` marker ⇒ everything is unread. */
export function countUnread(entries: ReleaseEntry[], lastSeenAt: string | null): number {
  return entries.filter(entry => !lastSeenAt || entry.publishedAt > lastSeenAt).length;
}
